import mySuxApi from '../services/dataSources/mySuxApi';

// constants
import * as ACTIONS from './constants';

// functions
import { getUserEvents, deleteUserEvent } from '../services/eventService';
import { equal } from '../services/jsonEqualityService';
// config
import { config } from '../config';

const URLS = config.URLS;

export const getEvents = () => (dispatch, getState) => {
  const state = getState();
  const { userGuid, userId, Authorization } = state.user;
  return getUserEvents(userGuid, userId, Authorization)
    .then((newEvents) => {
      if (!equal(state.eventFeed.events, newEvents, { ignoreArrayOrder: true })) {
        dispatch({ type: ACTIONS.UPDATE_EVENTS, payload: newEvents });
      }
    })
    .catch(() => dispatch({
      type: ACTIONS.UPDATE_EVENTS,
      payload: [
        {
          type: 'ErrorNotification',
          state: true,
          payload: {
            error: 'Something went wrong'
          }
        }
      ]
    }));
};


export const deleteEvent = (eventId, cardsToTakeWithMe) => (dispatch, getState) =>
  deleteUserEvent(getState().user.userGuid, eventId, cardsToTakeWithMe)
    .then(() => dispatch({ type: ACTIONS.REMOVE_EVENT, payload: { id: eventId, extras: cardsToTakeWithMe } }));


export const pushEventQueue = orderIdx => (dispatch, getState) => {
  const { userGuid, userId } = getState().user;
  const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/Messagequeue/push/${orderIdx}/${userId}`;
  return mySuxApi.post(url);
};


export const resetEventQueue = orderIdx => (dispatch, getState) => {
  const { userGuid, userId } = getState().user;
  const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/Messagequeue/cancel/${orderIdx}/${userId}`;
  return mySuxApi.post(url);
};


export const stepBackEventQueue = (flowId, orderIdx) => (dispatch, getState) => {
  const { userGuid, userId } = getState().user;
  const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/Messagequeue/Back/${flowId}/${orderIdx}/${userId}`;
  return mySuxApi.post(url);
};


// WEBPACK FOOTER //
// ./src/actions/cardEvents.js